import React from "react";
import { useCart } from "react-use-cart";
import style from "../../styles/freeShipping.module.scss";
import {
  FREE_SHIPPING_THRESHOLD,
  freeShippingProgress,
  merchandiseTotal,
} from "../../utils/pricing";

const FreeShipping = ({ total, variant = "bar" }) => {
  const { items } = useCart();
  const amount = typeof total === "number" ? total : merchandiseTotal(items);
  const { remaining, ratio, qualified } = freeShippingProgress(amount);
  const message = qualified
    ? "Posta falas për këtë porosi"
    : amount > 0
      ? `Edhe ${remaining.toFixed(2)}€ për postë falas`
      : `Posta falas mbi ${FREE_SHIPPING_THRESHOLD}€`;

  if (variant === "text") {
    return <span className={style.text}>{message}</span>;
  }

  return (
    <div className={style.progress}>
      <p>{message}</p>
      <div
        className={style.track}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={FREE_SHIPPING_THRESHOLD}
        aria-valuenow={Math.min(amount, FREE_SHIPPING_THRESHOLD)}
        aria-label={message}
      >
        <span style={{ width: `${ratio * 100}%` }} />
      </div>
    </div>
  );
};

export default FreeShipping;
